// extracted by mini-css-extract-plugin
export default {"mobileMenuModal":"MobileMenuModal_mobileMenuModal__PiVp3","closeMobileMenuModal":"MobileMenuModal_closeMobileMenuModal__tyf-m"};